import { getApiGalaxyServer } from 'services';

export interface IntegrationDisplayName {
  displayName: string;
  nonDisplayName: string;
}

/**
 * GET /service/integrationDisplayNames
 * Returns display names for all integration agents.
 * Each entry has a `displayName` (human-readable label) and `nonDisplayName` (integration identifier).
 */
export const getIntegrationDisplayNamesApi = ({ token, config = {} }: BaseApiParams<void>) => {
  return getApiGalaxyServer<IntegrationDisplayName[] | string[]>(
    `/service/integrationDisplayNames`,
    config,
    token,
  );
};
